import { TAX_SUF_WITHHOLDINGS_ITEM } from './tax-suf-withholdings.js'
import { TAX_SUF_PERCEPTIONS_ITEM } from './tax-suf-perceptions.js'

/** @type {import('../help-index.js').HelpScreen} */
export const TAX_SUF_HELP = {
  screenId: 'tax-suf',
  label: 'Perc. y Ret. Sufridas',
  navPath: 'Impuestos → Perc. y Ret. Sufridas',
  keywords: [
    'retención sufrida', 'percepción sufrida', 'certificado', 'compra', 'cobro',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Consultá retenciones que te practicaron al cobrar y percepciones en facturas de compra.',
  sidebarItems: [
    TAX_SUF_WITHHOLDINGS_ITEM,
    TAX_SUF_PERCEPTIONS_ITEM,
  ],
}
